export default {
	'changeAnswer': 'Ändern Sie die Antwort',
	'variables': 'Variablen',
	'variablesList': 'Liste der Variablen',
	'autoAnswers': 'Automatische Antworten',
	'deletionReminders': 'Deletion Reminders',
	'emailSubject': 'E-Mail-Betreff',
	'emailSubjectPlaceholder': 'Anfrage [@order_id@]',
	'download': 'Dateien herunterladen',
	"addTicket": "Kunde hinzüfugen",
	"addTask": "Aufgabe hinzufügen",
	"from": "Von",
	"to": "Bis",
	"reset": "Zurücksetzen",
	"searchByNameAndClient": "Suche nach Thema oder Kunde",
	'searchByCid': 'Suche nach CID',
	"save": "Speichern",
	"cancel": "Abbrechen",
	"chooseDate": "Datum wählen",
	"description": "Beschreibung",
	"taskView": "Beschreibung der Aufgabe",
	"date": "Datum",
	"ticket": "Bestellung",
	"setByAdmin": "Wichtig!",
	"delete": "Löschen",
	"done": "Abgeschlossen",
	"notDone": "Nicht abgeschlossen",
	"completedSuccessfully": "Erfolgreich abgeschlossen",
	"addedSuccessfully": "Erfolgreich hinzugefugt",
	"changedSuccessfully": "Erfolgreich geandert",
	"deletedSuccessfully": "Erfolgreich geloscht",
	"causedBy": "Problemtyp",
	"name": "Thema",
	"subject": "Fachbereich",
	"type": "Art der Arbeit",
	"pagesCount": "Seiten",
	'reasonFailed': 'Der Grund fur den Ausfall',
	"milestonesCount": "Teillieferungen",
	"priceEuro": "Honorar, €",
	"dueDate": "Deadline",
	"manager": "Manager",
	"comment": "Kommentar",
	"client": "Kunde",
	"level": "Qualitätslevel",
	"author": "Autor",
	"task": "Aufgaben",
	"new": "Neu",
	"clientNotAnswer": "Keine Antwort",
	"processing": "Verhandlung",
	"waitingPayment": "Warten auf Zahlung",
	"waitingAuthor": "Autorensuche",
	"inProgress": "In Bearbeitung",
	"waitingApprove": "Bestätigt",
	"completed": "Erledigt",
	"failedWithPayout": "Durchgefallen (Honorar bezahlt)",
	"failed": "Durchgefallen",
	'basket': 'Papierkorb',
	'promocode': "Promo-Code",
	'enterPromocode': "Promo-Code eingeben",
	'promocodeRequired': "Promo-Code ist erforderlich",
	'promocodeHint': "Geben Sie einen Promo-Code oder einen Bindestrich (−) ein, falls keiner vorhanden ist",
	'orderRestoredSuccessfully': 'Bestellung erfolgreich wiederhergestellt',
	'confirmBlockingUser': "Kundensperre bestätigen",
	'confirmUnblockingUser': "Bestätigen Sie die Client-Entsperrung",
	'confirmBlocking': "Sperre bestätigen",
	'confirmUnblocking': "Entsperren bestätigen",
	'ban_clients': "Blockierte Kunden",
	'user_banned_successfully': "Client erfolgreich blockiert",
	'user_unbanned_successfully': "Client erfolgreich entsperrt",
	'confirmUnblockingOrder': "Wiederherstellung der Bestellung bestätigen",
	'removalOrderReason': "Grund für die Löschung der Bestellung",
	'orderAddedToBasket': "Die Bestellung wurde in den Warenkorb verschoben",
	"createOrder": "Auftragserstellung",
	"newtonsLaw": "Newtonsches Gesetz",
	"clientsEmail": "E-Mail des Kunden",
	"site": "Website",
	"subjectArea": "Fachbereich",
	"workType": "Art der Arbeit",
	"isKi": "Nur für KI",
	"qualityLevel": "Qualitätslevel",
	"qualityBudget": "Budget",
	"qualityStandard": "Standard",
	"qualityPlus": "Plus",
	"qualityPremium": "Premium",
	"pagesAmount": "Anzahl der Seiten",
	"workLanguage": "Sprache",
	"language": "Sprache",
	"loadFile": "Datei hochladen",
	"create": "Erstellen",
	"orderWasCreatedSuccessfully": "Auftrag erfolgreich erstellt",
	"clientHasAnotherManagerConfirm": "Dieser Kunde ist einem anderen Manager ({manager}) zugewiesen. Auftrag erstellen und den Kunden sich selbst zuweisen?",
	"anotherManagerFallback": "ein anderer Manager",
	"order": "Bestellung",
	"currentOrderStatus": "Aktueller Auftragsstatus",
	'orderClosureStatus': 'Status der Auftragsfertigstellung',
	'closeOrder': 'den Auftrag abschließen',
	"price": "Honorar",
	"refuseWork": "Bestellung stornieren",
	'message': 'Nachricht',
	"writeMessage": "Nachricht schreiben",
	"openChat": "Löschen",
	"invitesWasSent": "Einladungen verschickt",
	"youMarkedOrderAs": "Sie haben den Auftrag markiert als",
	"confirmAction": "Vorgang bestatigen",
	"agree": "Start der Bestellung",
	"youWantToMarkOrderAs": "Sie sind dabei, den Auftrag zu markieren als",
	"totalWorks": "Auftrage insgesamt",
	"currentWorks": "Aktuelle Auftrage",
	'currentVsLimit': 'Aktuelle / Limit',
	"favorites": "Favoriten",
	"invite": "Einladen",
	"performersRequests": "Einsendungen der Autoren",
	"select": "Auswahlen",
	'selectTags': 'Tags auswählen',
	'selectReason': 'Wählen Sie den Grund aus',
	"yourRequestsWasSentSuccessfully": "Ihre Einladungen wurden erfolgreich verschickt.",
	"youHaveAssignedAuthorToThisProject": "Sie haben diesem Auftrag einen Autor zugewiesen",
	"attachedFiles": "Angehangte Dateien",
	"thanksWeReceivedYourRequest": "Vielen Dank, wir haben Ihre Anfrage erhalten",
	"managerWillConfirmItSoon": "Ein Manager wird sie in Kurze ubernehmen",
	"pleaseWait": "Bitte warten",
	"details": "Details",
	'client_file': 'Client file',
	"stage": "Phase",
	"priceForClient": "Preis fur Kunde",
	'priceForNative': "Preis fur Native",
	"priceForJuniorAndMiddle": "Preis fur Middle",
	"priceForSenior": "Preis fur Senior",
	"pagesAmountShort": "Anzahl der Seiten",
	"loadPhoto": "Foto hochladen",
	"recommendedPaymentSum": "Empfohlener Zahlungsbetrag",
	"totalPaymentSum": "Zu zahlender Gesamtbetrag",
	"lowerThanRecommendedSum": "Menge weniger als empfohlen",
	"addStage": "Teillieferung hinzufügen",
	"sendForApproval": "Zur Bestätigung senden",
	"edit": "Bearbeiten",
	"approve": "Bestätigen",
	"firstlyAddWorkTypeToOrder": "Art des Auftrags wahlen",
	"youConfirmedPaymentSuccessfully": "Sie haben die Zahlung erfolgreich genehmigt",
	"dataWasSentToClientForApproval": "Die Dateien wurden an den Kunden gesendet",
	"dataWasSentForApproval": "Dokument zur Freigabe gesendet",
	"youMarkedStageAs": "Sie haben den Schritt markiert als",
	"stageWasMovedToStatus": "Auftragsstatus andern: ",
	"payRewardToAuthor": "Autorenvergutung zahlen",
	"authorsReward": "Höhe der Honorare",
	'failureType': 'Ausfallkategorie',
	"pay": "Zahlen Sie",
	"doCancel": "Abbrechen",
	"indicateFailureReason": "Geben Sie den Grund fur den Ausfall an",
	"informationAboutOrder": "Auftragsinformationen",
	'workTheme': 'Thema der Arbeit',
	"workName": "Thema",
	"clientsComment": "Kommentar des Kunden",
	"recommendedSumShort": "Referenzbetrag",
	"add": "Hinzufügen",
	"attachedFile": "0 angehangte Dateien | {n} Angehangte Datei | {n} angehangte Dateien | {n} angehangte Dateien | vor {n} angehangte Dateien",
	"paymentMethod": "Zahlungsmethode",
	"filesFromAuthor": "Dateien des Autors",
	"send": "Absenden",
	"sendAutomatically": "Automatisch senden",
	"filesWasSentToClient": "Die Dateien wurden an den Kunden gesendet",
	'filesFromClient': 'Dateien vom Kunden',
	'notAllowedFileType': 'Dieser Dateityp ist für den Upload nicht erlaubt.',
	"refuse": "Ablehnen",
	"youWantToCompleteOrder": "Sie sind dabei, den Auftrag zu beenden",
	"thisActionIsIrreversible": "Diese Aktion ist unumkehrbar",
	"completeOrder": "Auftrag abschließen",
	"orderIsCompletedSuccessfully": "Auftrag wurde erfolgreich abgeschlossen",
	"writeToManager": "Nachricht an den Manager",
	"discuss": "Wird besprochen",
	"creationDate": "Erstellungsdatum",
	"calculatedSum": "Geschätzter Preis",
	"includingVAT": "inkl. MwSt.",
	"assign": "Beauftragen",
	"chooseManager": "Manager auswahlen",
	"passwordRecovery": "Passwort wiederherstellen",
	"enterYourEmailAndWeWillSendYouNewPassword": "Geben Sie Ihre E-Mail ein und wir senden Ihnen ein neues Passwort zu",
	"recoverPassword": "Passwort wiederherstellen",
	"toLoginPage": "Login-Seite",
	"newPasswordIsGeneratedAndSentToMail": "Neues Passwort wurde per E-Mail gesendet",
	"registration": "Anmelden",
	"fillFormBelowToCreateNewAccount": "Fullen Sie das folgende Formular aus, um ein neues Konto zu erstellen",
	"youAreAlreadyLoggedIn": "Sie sind bereits eingeloggt!",
	"entrance": "Einloggen",
	"welcomeBack": "Willkommen zurück!",
	"pleaseLoginToYourAccount": "Bitte melden Sie sich mit Ihrem Konto an",
	"password": "Passwort",
	"repeatPassword": "Passwort wiederholen",
	"newPassword": "Neues Passwort",
	"yes": "Ja",
	"no": "Nein",
	"confirmDeletion": "Loschung bestatigen",
	"doYouWantToDelete": "Sie sind dabei etwas zu löschen",
	"registrationLinkCreation": "Registrierungslink erstellen",
	"linkToRegistrationForm": "Link zum Anmeldeformular",
	"generate": "Erstellen",
	"close": "Schließen",
	"nickname": "Benutzername",
	"emailForPayment": "SEPA/SWIFT IBAN",
	"paymentDetails": "Payment details",
	"phone": "Telefonnummer",
	"sex": "Geschlecht",
	"country": "Land",
	"birthDate": "Geburtsdatum",
	"surname": "Nachname",
	"profile": "Profil bearbeiten",
	"subjects": "Fachbereiche",
	'undesirableSubjects': 'Unerwünschte Themen',
	"aboutYourself": "Über mich",
	"dataIsSaved": "Daten gespeichert",
	"totalOrdersCount": "Gesamtzahl der Aufträge",
	"success": "Erfolgsquote",
	"personName": "Vorname",
	"changeWorkType": "Arbeitstyp andern",
	"shortRussian": "Russisch",
	"shortGerman": "Deutsch",
	"totalTicketsAmount": "Gesamtzahl der Aufträge",
	"activatedTickets": "Aktive Aufträge",
	"income": "Einnahmen",
	"totalIncome": "Gesamteinnahmen",
	"clientEditing": "Kunde bearbeiten",
	"additionalEmail": "Zusätzliche E-Mail",
	"activatedOrder": "Aktuelle Auftrage",
	"changingManagerRequest": "Anfrage auf Anderung des Managers",
	"newManager": "Neuer Manager",
	"confirm": "Bestätigen",
	"decline": "Ablehnen",
	"firstlySelectManager": "Neuen Manager auswahlen",
	"changingManagerRequestIsSent": "Anfrage auf Anderung des Managers wurde gesendet",
	"requestWasDeclined": "Anfrage wurde storniert",
	"searchByName": "Suche nach Name",
	"searchByPhone": "Suche nach Telefonnummer",
	"actions": "Aktionen",
	"totalOrders": "Auftrage insgesamt",
	"paidOrder": "Bezahlte Auftrage",
	"hangingOrders": "Leerlaufauftrage",
	"sitesPreferences": "Einstellungen fur Seiten",
	"managerEditing": "Manager bearbeiten",
	"managerCreating": "Manager registrieren",
	"sitesSettings": "Seiteneinstellungen",
	"basicPrices": "Grundpreise",
	"workTypesVisibility": "Sichtbarkeit der Arbeiten",
	"invoicesData": "Rechnungsdaten",
	"changesIsSavedSuccessfully": "Anderungen wurden erfolgreich gespeichert",
	"siteWasCreatedSuccessfully": "Seite wurde erfolgreich erstellt",
	"managersFee": "Managervergütung",
	"deleteLogo": "Logo löschen",
	"firmInfo": "Unternehmensinfo",
	"termsAndConditions": "Allgemeine Geschäftsbedingungen",
	"part": "Abschnitt",
	"changeLogo": "Logo ändern",
	"mainLogo": "Primarfarbe",
	"additionalColor": "Zusatzliche Farbe",
	"showForJunior": "Anzeigen fur Junior",
	"showForMiddle": "Anzeigen fur Middle",
	"showForSenior": "Anzeigen fur Senior",
	"general": "Allgemein",
	"bySites": "Nach Seiten",
	"openDiscuss": "Anfrage öffnen",
	"opened": "Offene",
	"number": "Nummer",
	"discussTheme": "Betreff der Anfrage",
	"status": "Status",
	'order_limit': 'Limit bestellen',
	"lastAnswer": "Letzte Antwort",
	"answerReceived": "Antwort erhalten",
	"waitingToAnswer": "Warten auf Antwort",
	"closed": "Geschlossene",
	"isClosed": "Geschlossen",
	"openNewDiscuss": "Neue Anfrage öffnen",
	"discussText": "Text der Anfrage",
	"doYouWantToCloseDiscuss": "Sie sind dabei, die Anfrage zu schließen",
	"closeDiscuss": "Anfrage schließen",
	"aDiscuss": "Anfrage",
	"discussStatus": "Status der Anfrage",
	"write": "Schreiben",
	"techSupport": "Technischer Support",
	"pendingConsideration": "Ausstehend",
	"paidOut": "Bezahlt",
	"rejected": "Abgelehnt",
	"payRequest": "Geld abheben",
	"writeHowMuchYouWantToWithdraw": "Geben Sie an, wie viel Geld Sie abheben möchten",
	'pleaseFillPaymentDetails': 'Abhebung ist nicht erlaubt, füllen Sie zuerst die Zahlungsdetails aus.',
	"rejectPayment": "Zahlung ablehnen",
	"paymentRejectingReason": "Grund fur die Ablehnung der Zahlung",
	"currentBalance": "Aktueller Saldo",
	"withdraw": "Abheben",
	"rejectSuccessfully": "Erfolgreich abgelehnt",
	"idTransaction": "Transaktions-ID",
	"sum": "Betrag",
	"paymentSystem": "Zahlungssystem",
	"paymentRequests": "Zahlungsaufforderungen",
	"paymentsHistory": "Zahlungsverlauf",
	"accrualHistory": "Verlauf von Anrechnungen",
	'ordersHistory': "Historie der Bestellung",
	"user": "Benutzer",
	"rejectedPayments": "Abgelehnte Zahlungen",
	"addWorkType": "Arbeitstyp hinzüfugen",
	"responseText": "Antworttext",
	"addAnswer": "Antwort hinzüfugen",
	"ago": "zuruck",
	"month(1)": "Monat",
	"month(2-5)": "Monate",
	"month(6-0)": "Monate",
	"more": "Mehr",
	"lessThanMonth": "Weniger als ein Monat",
	"markAllAsRead": "Alle als gelesen markieren",
	"orders": "Aufträge",
	"techSupportShort": "Technischer Support",
	"exchangePageName": "Börse",
	"tickets": "Aufträge",
	"statistics": "Statistik",
	"finances": "Finanzen",
	"tasks": "Aufgaben",
	"clients": "Kunden",
	"managers": "Manager",
	'logs': "Manager Logs",
	"authors": "Autoren",
	"sites": "Seiten",
	"workTypes": "Arbeitstypen",
	"templateAnswers": "Antwortvorlagen",
	"scheduledTasks": "Aufgaben",
	"all": "Alle",
	'reason': "Ursache",
	"deleted": "Im Korb",
	'clean': "Löschen",
	"notDone(many)": "Aktuell",
	"sort": "Sortieren",
	"tasksCalendar": "To-Do-Liste",
	"languages": "Sprachen",
	"accessDenied": "Zugriff verweigert",
	"addPhoto": "Foto hinzüfugen",
	'addTag': "Tag hinzufügen",
	"male": "Mannlich",
	"female": "Weiblich",
	"searchByOrderName": "Suche nach Begriff...",
	"addOrder": "Auftrag hinzüfugen",
	"doYouWantToRejectOrder": "Sie mochten Ihren Auftrag stornieren",
	"yourPersonalManager": "Ihr personlicher Manager",
	"requestAnotherManager": "Einen anderen Manager anfordern",
	"writeReason": "Nennen Sie bitte den Grund",
	"profileEditing": "Profil bearbeiten",
	"changePhoto": "Foto ändern",
	"deletePhoto": "Foto löschen",
	"chatWithYourManager(p1)": "Chatten Sie mit Ihrem",
	"chatWithYourManager(p2)": "Manager",
	"chatByOrder": "Auftrags-Chat",
	"search": "Suche",
	"copywriter": "Autor",
	"admin": "Administrator",
	"successNotification": "Erfolgreich",
	"dangerNotification": "Achtung",
	"errorNotification": "Fehler",
	"fieldFilledIncorrect": "Das Feld wurde nicht oder falsch ausgefüllt",
	'rescheduleReason': 'Grund für die Verschiebung',
	'workLongTerm': 'Langfristigе Arbeiten',
	'additionalSale': 'Zusatzverkauf',


	// -------- V2
	"newMessagesCountDisplay": "Neu",
	"logout": "Ausloggen",
	'english': "English",
	"russian": "Russisch",
	"german": "Deutsch",
	'french': "French",
	'locale': "Locale",
	"sunday": "Sonntag",
	"monday": "Montag",
	"tuesday": "Dienstag",
	"wednesday": "Mittwoch",
	"thursday": "Donnerstag",
	"friday": "Freitag",
	"saturday": "Samstag",
	"sundayShort": "So",
	"mondayShort": "Mo",
	"tuesdayShort": "Di",
	"wednesdayShort": "Mi",
	"thursdayShort": "Do",
	"fridayShort": "Fr",
	"saturdayShort": "Sa",
	"january": "Januar",
	"february": "Februar",
	"march": "März",
	"april": "April",
	"may": "Mai",
	"june": "Juni",
	"july": "Juli",
	"august": "August",
	"september": "September",
	"october": "Oktober",
	"november": "November",
	"december": "Dezember",
	"januaryGenitive": "Januar",
	"februaryGenitive": "Februar",
	"marchGenitive": "März",
	"aprilGenitive": "April",
	"mayGenitive": "Mai",
	"juneGenitive": "Juni",
	"julyGenitive": "Juli",
	"augustGenitive": "August",
	"septemberGenitive": "September",
	"octoberGenitive": "Oktober",
	"novemberGenitive": "November",
	"decemberGenitive": "Dezember",
	// -------- end V2

	// -------- V3
	"topic": "Thema",
	"finished": "Fertig",
	"incomeTotal": "Gross",
	"stages": "Teillieferungen",
	"confirmUploading": "Herunterladen bestätigen",
	"fileDeletedSuccessfully": "Datei wurde erfolgreich gelöscht",
	"isConfirmingStage": "Die Phase ist jetzt auf die Bestätigung des Managers",
	"changeTemplateAnswer": "Ändern Sie die Antwort der Vorlage",
	"pages": "{n} Seiten | {n} Seite | {n} Seiten | {n} Seiten",
	"fileDeletionError": "Beim Versuch, eine Datei zu löschen, ist ein Fehler aufgetreten",
	"doYouWantToDeleteAuthorFromOrder": "Sie werden den Autor aus dem Auftrag entfernen",
	"doYouWantToDeleteFile": "Sie sind im Begriff, eine Datei zu löschen",
	"youDeletedAuthorFromOrder": "Sie haben den Autor aus diesem Auftrag entfernt",
	"mainColor": "Hauptfarbe",
	"noDataAvailable": "Keine Daten wurden gefunden",
	"secondsAgo": 'vor 0 Sekunden | vor {n} Sekunde | vor {n} Sekunden | vor {n} Sekunden | vor {n} Secunden',
	"minutesAgo": "vor 0 Minuten | vor {n} Minute | vor {n} Minuten | vor {n} Minuten | vor {n} Minuten",
	"hoursAgo": "vor 0 Stunden | vor {n} Stunde | vor {n} Stunden | vor {n} Stunden | vor {n} Stunden",
	"daysAgo": "vor 0 Tage | vor {n} Tag | vor {n} Tage | vor {n} Tage | vor {n} Tagen",
	"yearsAgo": "vor 0 Jahre | vor {n} Jahr | vor {n} Jahre | vor {n} Jahre | vor {n} Jahren",
	"justNow": "Einfach jetzt",

	"followUP" : "Statusanfrage",


	"statusRequest1": "Statusanfrage 1",
	"statusRequest2": "Statusanfrage 2",
	"statusRequest3": "Statusanfrage 3",
	"statusRequest4": "Statusanfrage 4",
	"statusRequest5": "Statusanfrage 5",

	"waitingForPayment1": "Warten auf Zahlung 1",
	"waitingForPayment2": "Warten auf Zahlung 2",
	"waitingForPayment3": "Warten auf Zahlung 3",

	"offerFollowUp": "Ofer",
	"deleteFollowUp" : "Löschen",


	// -------- end V3

	"workTypeName": "Pakete",
	"packagePaid": "Kaufdatum des Pakets",
	"packageExpiry": "Gültigkeitsdauer des Pakets",


	"exchange": {
		"name": "Thema",
		"area": "Fachbereich",
		"type": "Art der Arbeit",
		"page": "Seiten",
		"stage": "Teillieferungen",
		"price": "Honorar",
		"price_junior_middle": "Preis für Junior/Middle",
		"price_senior": "Preis für Senior",
		"deadline": "Deadline",
		"accept": "Zur Bearbeitung annehmen",
		"decline": "Ablehnen",
		"confirmAction": "Aktion bestätigen",
		"confirmActionText": "Sie sind dabei, diesen Auftrag anzunehmen.",
		"confirmActionTextFalse": "Sie sind dabei, diesen Auftrag abzulehnen.",
		"confirmPopup": "Bestätigen",
		"order": "Auftrag",
		"countStages": "Anzahl der Phasen",
		'workTheme': 'Thema der Arbeit',
		"subject": "Fachbereich",
		"typeWork": "Art der Arbeit",
		"levelQuality": "Qualitätslevel",
		"countPages": "Anzahl der Seiten",
		"attachFile": "Angehängte Dateien",
		"langWork": "Bearbeitungssprache",
		"comment": "Kommentar",
		"getToWork": "Start!",
		"filter": "Filter",
		"searchToName": "Suche nach Begriff...",
		"level": "Qualitätslevel",
		"off": "Von",
		"to": "Bis",
		"reset": "Zurücksetzen",
		"inviteDecline": "Einladung abgelehnt",
		"inviteDeclineText": "Sie haben die Einladung erfolgreich abgelehnt. Sollten Sie es sich anders überlegen, können Sie weiterhin einen Antrag für diesen Auftrag einreichen.",
		"inviteAccept": "Einladung angenommen",
		"inviteAcceptText": "Vielen Dank, Sie können nun mit der Arbeit beginnen.",
		"requestSend": "Die Anfrage wurde gesendet",
		"requestSendText": "Vielen Dank, wir haben Ihre Anfrage erhalten. Ein Manager wird sie in Kürze übernehmen. Bitte warten.",
		"success": "Erfolgreich",
		"successText": "Erfolgreich durchgeführt",
		"deleteText": "Erfolgreich gelöscht",
		"acceptText": "Erfolgreich hinzugefügt"
	},

	"stats": {
		"junior": "Economy",
		"middle": "Business",
		"senior": "Academic",
		"income": "Insgesamt erhalten",
		"total": "Reingewinn",
		"totalIncome": "Einnahmen",
		"privateIncome": "Persönliche Einnahmen",
		"sitesCount": "Seiten",
		"paidOrdersCount": "Bezahlte Aufträge",
		"waitingOrdersCount": "Leerlaufaufträge",
		"graphIncomeTotal": "Grafik Gesamteinnahmen",
		"graphIncome": "Grafik persönliche Einnahmen",
		"graphOrders": "Aufträge",
		"graphIncomeGlobal": "Einkommen",
		"graphOrdersPaid": "Grafik der Leerlaufaufträge",
		"completeOrder": "Abgeschlossene Aufträge",
		"successOrder": "Erfolgsquote",
		"today": "Heute",
		"yesterday": "Gestern",
		"currentWeek": "Aktuelle Woche",
		"prevWeek": "Letzte Woche",
		"current_month": "Aktueller Monat",
		"last_month": "Letzter Monat",
		"last_three_month": "3 Monate",
		"last_six_month": "Halbes Jahr",
		"last_year": "Jahr",
		"all_time": "Gesamte Zeit",
		"active": "Aktive Aufträge",
		"clientsCount": "Kunden",
		"authorsCount": "Autoren",
		"managersCount": "Manager",
		"salesManagers": "Verkaufsmanager",
		"salesSites": 'Verkäufe nach Standorten',
		"totalPaymentsForPeriod": 'Gesamtzahlungen für den Zeitraum',
		"totalPaidForPeriod": 'Für den Zeitraum gezahlter Gesamtbetrag',
		"incomeTotal": "Brutto",
		"incomeClean": "Netto",
		"ordersCount": "Aufträge insgesamt",
		"graphUsers": "Neue Benutzer",
		"graphQualityLevels": "Aufträge nach Qualitätsstufe",
		"graphSubjects": "Aufträge nach Thema",
		"graphAdminIncome": "Brutto/Netto-Verhältnisse",
		"newPaidTickets": "Bestellungen",
		"completedTickets": "Abgeschlossen/Gescheitert",
		"conversion": "Konversion",
		"date": "Datum",
		"manager": "Manager",
		"clients": "Kunden",
		"authors": "Autoren",
		"mangers": "Manager",
		"graph_new": "Neue Tickets",
		"paid": "Bezahlte Tickets",
		"completed": "Abgeschlossen",
		"failed": "Gescheitert",
    "countOfRefunds": "Anzahl der Rückgaben",
    "sumOfRefunds": "Erstattungsbetrag",
    "penalties": "Geldbußen",
    "manualCredits": "Manuelle Einschreibung",
    "fails": "Ausfälle",
    "countOfFails": "Anzahl der Verstöße",
    "leeds": "Leeds"
	},
	"changePrice": "Preis ändern",
	"searchById": "Suche nach ID",
	"wrongField": "Falsches Feld",
	"forThisDay": "Ab heute",
	"№": "№",
	"plagiatPercentage": "Prozentsatz der Plagiate",
	"reportFile": "Berichtsdatei",
	"writeMessageToAuthor": "Schreiben Sie an den Autor",
	"writeMessageToClient": "An Kunden schreiben",
	"chatWithAuthor": "Chat mit dem Autor",
	"chatOpenTooLong": "Der Chat war zu lange inaktiv. Melden Sie sich erneut an, um weiter zu chatten.",

	"createSuborder": "Unterauftrag",
	"markAsRead": "Als gelesen markieren",
	"archive": "Archiv",
	"chat": "Chat",
	"info": "Info",
  "comments": "Kommentar",
  "view": "Siehe",
  "changeBalance": "Neugewichtung",
  "balanceIn": "Hinzufügen",
  "balanceOut": "Abzüglich",
  "paymentAmount": "Betrag der Zahlung",
  "workIsPaidCanContinue": "Der Kunde hat für diesen Teil bezahlt, Sie können an dem Auftrag weiterarbeiten.",
  "workIsNotPaidWait": "Der Kunde hat noch NICHT für diesen Teil bezahlt, bitte warten Sie auf eine Nachricht vom Manager, um mit der Arbeit zu beginnen.",
  "assignAnOrder": "Den Auftrag sichern",
  "externalEmails": "Zusätzliche Mail",
  "priceForMiddle": "Preis fur Middle",
	"unreadMessages": "Ungelesene Textnachrichten",
  "markAsProblem": "Als problematisch markieren",
  "problemAuthor": "Problem Autor",
  "authorMarkedAsProblem": "Autor als problematisch markiert",
  "otherProfiles": "Andere Profile",
  "refund": "Rückgabe",
  "refunds": "Rückgaben",
  "refundReasons": "Gründe für Rückgaben",
	'indicateRefundReason': "Geben Sie den Grund für die Rückgabe an",
  "penalty": "Strafe",
	"needPenalty": "Brauchen Sie eine Strafe?",
	"lateness": "Verspätung",
	"authorsRequest": "Anfrage des Autor",
	"unableToCompleteOrder": "Bestellung kann nicht abgeschlossen werden",
	"other" : "Andere",
	"instructionsNotFollowed" : "Anweisungen nicht befolgt",
	"plagiarism" : "Plagiat",
	"AI" : "AI",
	"reassignReason": "Gründe für die Neuordnung",
	"qualityIssue": "Qualitätsproblem",
	"reassign": "Neu zuweisen",
	"reassignAuthor": "Autor neu zuweisen",
	"requiredField": "Das ist ein Pflichtfeld",
	"chooseAuthorReassignReason": "Bitte wählen Sie den Grund für die Neuzuweisung dieses Autors",
	"shareDetailsAboutReassign": "Bitte teilen Sie uns weitere Einzelheiten darüber mit, warum der Autor neu zugewiesen wird",
	"warning": "Achtung",
  	"penaltySum": "Höhe der Geldbuße",
	"uploadWarning": "Erfolgreich hochgeladen: {success} von {total} Dateien.",
  "penaltiesSum": "Höhe der Geldbußen",
  "sumOfRefunds": "Erstattungsbetrag",
  "choosePenaltyReason": "Geben Sie den Grund für die Geldstrafe an",
  "penaltyAmount": "Höhe der Geldbuße",
  "penaltyReason": "Grund der Geldbuße",
  "penaltyCount": "Anzahl der Geldbußen",
  "pricePerPage": "Preis pro Seite",
  "operation": {
    "title":"Operation",
    "in":"Hinzugefügt",
    "out":"Abgeschrieben",
  },
  "amountOfIncome": "Höhe der Einkünfte",
  "confirmPaymentManually": "Zahlung manuell bestätigen",
	"accountant": "Buchhalter",
  "marginality": "Marginalität",
  "marginalityConfirmationText": "Die Marge liegt unter dem geforderten Minimum (das Honorar des Autors ist zu hoch). Sind Sie sicher, dass die Informationen korrekt sind?",
  "failsReasons": "Ursachen des Scheiterns",
  "marginalityWarning": 'HINWEIS: DIE GEWINNSPANNEN LIEGEN UNTER DEN NORMALEN WERTEN.',
  "orderPriceIncorrectWarning": "HINWEIS: DER PREIS WEICHT VON DER PREISEMPFEHLUNG UM MEHR ALS 10% AB.",
  "confirmPayment": "Bestätigen Sie die Zahlung",
  "totalActions": "Anzahl der Aktionen",
  "wordsCount": "Wortzahl",
  "downloadActs": "Akte downloaden",
  "answerTime": "Reaktionszeit",
  "replyTypes": "Antworttyp",
  "minutesShort": "min.",
  "averageAnswerTimeBy": "Durchschnittliche Reaktionszeit, Minuten",
  "averageAnswerTime": "Durchschnittliche Reaktionszeit",
  "noAnswer": "Keine Antwort",
  "authorDidNotChooseMainBankCard": "Der Autor hat keine Hauptkarte gewählt",
  "youDidNotChooseMainBankCard": "Sie haben keine Hauptkarte ausgewählt",
  "bankCards": "Bankkarten",
  "updateCardsList": "Aktualisieren Sie die Liste der Karten",
  "toUpdateCardsListYouMustToWait": "Um die Liste der Karten zu aktualisieren, müssen Sie warten {n} min.",
  "bankCardsFromSolarStaff": "Bankkarten (erhalten von solar-staff)",
	'updatedSuccessfully': "Erfolgreich aktualisiert",
	"stagesTotal": "Etappen (insgesamt)",
  "check": "Siehe",
  "fileWillBeCheckedAsSoonAsPossible": "Die Datei wird in Kürze geprüft",
  "group": 'Gruppe',
  "activeOrdersCount": "Anzahl der aktiven Aufträge",
  "activeOrders": "Aktive Aufträge",
  "orderId": "Ordnungsnummer",
  "doNotNotifyClient": "Den Kunden nicht zu informieren",
  "totalLeadsByPeriod": "Aufträge insgesamt im Berichtszeitraum",
  "totalPayedLeadsByPeriod": "Summe der für den Zeitraum bezahlten Aufträge",
  "ignoreSpam": "Rabatt-Spam",
  'searchByName': 'Suche nach Begriff',
  'emptyList': 'Die Liste ist leer',
  "conversionPercent": "Umrechnungskurs",
  "maxValue": "Maximaler Wert {n}",
  "fieldRequired": "Obligatorisches Feld",
  "minLength": "Minimum {n}",
  "maxLength": "Maximum {n}",
  "utm": {
	"matchtype":"Match type",
	"gclid":"GCLID",
	"wbraid":"WBRAID",
	"gbraid":"GBRAID",
	"fbclid":"FBCLID",
    "utm_medium":"UTM medium",
    "utm_source":"UTM source",
    "utm_term":"UTM Term",
    "utm_campaign":"UTM Campaign",
    "adgroupid":"Ad group ID",
    "targetid":"Target ID",
    "orderSource": "Ticket source",
    "source": "Source",
    "search_word": "Search word",
    "cid": "CID",
    "geo": "GEO",
    "medium": "Medium",
    "browser_agent": "Browser agent",
    "sid": "SID",
    "sct": "SCT"
   },
  "orderHistory": {
    "entityType": "Entitätstyp",
    "initiatorRole": "Rolle",
    "initiatorName": "Initiator",
    "field": "Feld",
    "old": "Alter Wert",
    "new": "Neuer Wert",
    "createdAt": "Erstellt am"
  },
	"skipReminders": "Do not send reminders",
	"contactTimeReminders": "Erinnerung für die Kontaktaufnahme",
	"doNotDeleteOrderAfterEmails": 'Anfrage nach E-Mails nicht löschen',
	"sendDeletionReminders": 'Erinnerungen nach Löschung senden',

	"uploadAuthorFilesInstruction": "Bitte senden Sie Ihre Arbeit an den Chat mit dem Manager",
	"downloadAuthorsFiles": "Dateien des Autors herunterladen",
	"qualityAssurance": "Qualitätssicherung",
	"problemsWithQuality": "Qualitätsprobleme",
	"quality": "Qualität",
	"sendpulse": {
		"resubscriptionRequested": "Re-subscription request have been sent. Client not receiving a message from CRM until they accept it. If it takes too much time or there is something urgent, use the website mail directly to contact client. Client unsubscribed from : {unsubscribe_date}",
		"unsubscribed": "The client has unsubscribed from emails sent via sendpulse. They are not receiving a message from CRM at this time. In case of urgent need, it is necessary to use the website mail directly. If the customer sends us a message, a re-subscription request will be sent automatically. Client unsubscribed from : {unsubscribe_date}",
	},
	"mailjet": {
		"resubscriptionRequested": "Re-subscription request have been sent. Client not receiving a message from CRM until they accept it. If it takes too much time or there is something urgent, use the website mail directly to contact client. Client unsubscribed from : {unsubscribe_date}",
		"unsubscribed": "Der Kunde hat sich von Marketing-E-Mails abgemeldet, die über Mailjet versendet werden. System-E-Mails aus dem CRM werden weiterhin zugestellt. Marketing-Kampagnen sind deaktiviert, bis sich der Kunde erneut anmeldet. Kunde abgemeldet am: {unsubscribe_date}",
	},
	"authorDeadline": "Author deadline",
	"deadlineCalculatedApproximately": "Solange der Kunde die nächsten Meilensteine nicht bezahlt hat, wird die Frist nur ungefähr berechnet. Die endgültige Frist für den Meilenstein wird angezeigt, sobald der Kunde den vorherigen Meilenstein genehmigt und für den nächsten bezahlt hat.",
	"offerSent": "Offer sent",
	"guidesHint": "Dies ist eine Seite, auf der alle unsere Politiken an einem Ort gesammelt werden. Hier finden Sie alles, was Sie brauchen, um erfolgreich auf unserer Plattform zu arbeiten.",
	"policiesAndGuides": "Policies & guides",
	"howToUse": "Policies and guides",
	"contactViaWhatsapp": "Kontakt über WhatsApp",
	"contactPhone": "Telefonnummer",
	'contactTime': "Zeitpunkt für die Kontaktaufnahme",
	"changeStatus": "Change status",
	"forceChangeStatus": "Change ticket status without any additional notifications or related logics. Note!!! it can affect ticket workflow",
	"ticketStatus": "Ticket status",
	"activeMilestone": "Active stage",
	"activeMilestoneStatus": "Active stage status",
	"globalSettings": "System settings",
	"systemSettings": {
		"create_order_new_email": "Create order from first email from new client"
	},
	"systemSettingsGroup": {
		"main": "General"
	},
	"authorHint" : "Bitte laden Sie die Datei im .doc oder .docx Format hoch (sofern vom Kunden nicht anders gewünscht). <br>Stellen Sie sicher, dass Ihre Datei keine Metadaten über Sie enthält. Hier finden Sie eine Anleitung, wie Sie <a href='https://criticalfault.com/blog/how-to-remove-metadata-from-word-documents/' target='_blank'>Metadaten aus Ihrem Dokument entfernen können</a>",


	// 'addTicket': "Добавить тикет(de)",
	// 'addTask': "Добавить дело(de)",
	// 'from': "От(de)",
	// 'to': 'До(de)',
	// 'reset': "Сбросить(de)",
	// 'searchByNameAndClient': "Поиск по названию и клиенту(de)",
	// 'save': "Сохранить(de)",
	// 'cancel': "Отмена(de)",
	// 'chooseDate': "Выберите дату(de)",
	// 'description': "Описание(de)",
	// 'taskView': "Просмотр дела(de)",
	// 'date': "Дата(de)",
	// 'ticket': "Тикет(de)",
	// 'setByAdmin': "Назначено админом(de)",
	// 'delete': "Удалить(de)",
	// 'done': "Выполнено(de)",
	// 'notDone': "Не выполнено(de)",
	// 'completedSuccessfully': "Успешно выполнено(de)",
	// 'addedSuccessfully': "Успешно добавлено(de)",
	// 'changedSuccessfully': "Успешно изменено(de)",
	// 'deletedSuccessfully': "Успешно удалено(de)",
	// 'name': "Название(de)",
	// 'subject': "Область(de)",
	// 'type': "Тип(de)",
	// 'pagesCount': "Страниц(de)",
	// 'milestonesCount': "Этапов(de)",
	// 'priceEuro': "Цена, €(de)",
	// 'dueDate': "Дедлайн(de)",
	// 'manager': "Менеджер(de)",
	// 'comment': "Комментарий(de)",
	// 'client': "Клиент(de)",
	// 'level': "Уровень(de)",
	// 'author': "Автор(de)",
	// 'task': "Дела(de)",
	// 'new': "Новый(de)",
	// 'clientNotAnswer': "Клиент не отвечает(de)",
	// 'processing': "В обработке(de)",
	// 'waitingPayment': "Ожидает оплаты(de)",
	// 'waitingAuthor': "В поиске исполнителя(de)",
	// 'inProgress': "В процессе(de)",
	// 'waitingApprove': "Подтверждается(de)",
	// 'completed': "Выполнен(de)",
	// 'failedWithPayout': "Не выполнен c выплатой(de)",
	// 'failed': "Не выполнен(de)",
	// 'createOrder': "Создание заказа(de)",
	// 'newtonsLaw ': "Закон Ньютона(de)",
	// 'clientsEmail': "Email Клиента(de)",
	// 'site': "Сайт(de)",
	// 'subjectArea': "Предметная область(de)",
	// 'workType': "Тип работы(de)",
	// 'qualityLevel': "Уровень качества(de)",
	// 'pagesAmount': "Количество страниц(de)",
	// 'workLanguage': "Язык выполнения(de)",
	// 'language': "Язык(de)",
	// 'loadFile': "Загрузить файл(de)",
	// 'create': "Создать(de)",
	// 'orderWasCreatedSuccessfully': "Заказ успешно создан(de)",
	// 'order': "Заказ(de)",
	// 'currentOrderStatus': "Текущий статус заказа(de)",
	// 'price': "Цена(de)",
	// 'refuseWork': "Отказаться от работы(de)",
	// 'writeMessage': "Написать сообщение(de)",
	// 'openChat': "Открыть чат(de)",
	// 'invitesWasSent': "Приглашения отправлены(de)",
	// 'youMarkedOrderAs': "Вы отметили заказ как(de)",
	// 'confirmAction': "Подтвердите действие(de)",
	// 'agree': "Согласиться(de)",
	// 'youWantToMarkOrderAs': "Вы собираетесь отметить заказ как(de)",
	// 'totalWorks': "Всего работ(de)",
	// 'currentWorks': "Текущих работ(de)",
	// 'favorites': "Избранные(de)",
	// 'invite': "Пригласить(de)",
	// 'performersRequests': "Заявки исполнителей(de)",
	// 'select': "Выбрать(de)",
	// 'yourRequestsWasSentSuccessfully': "Ваши приглашения были успешно отпралены(de)",
	// 'youHaveAssignedAuthorToThisProject': "Вы назначили автора на этот проект(de)",
	// 'attachedFiles': "Прикрепленные файлы(de) | Прикрепленный файл(de) | Прикрепленные файлы(de) | Прикрепленные файлы(de)",
	// 'thanksWeReceivedYourRequest': "Спасибо, мы получили вашу заявку(de)",
	// 'managerWillConfirmItSoon': "Менеджер скоро ее подтвердит(de)",
	// 'pleaseWait': "Пожалуйста, подождите(de)",
	// 'paymentDetails': "Детали оплаты(de)",
	// 'stage': "Этап(de)",
	// 'priceForClient': "Цена для клиента(de)",
	// 'priceForJuniorAndMiddle': "Цена для Junior & Middle(de)",
	// 'priceForSenior': "Цена для Senior(de)",
	// 'pagesAmountShort': "Кол-во страниц(de)",
	// 'loadPhoto': "Загрузить фото(de)",
	// 'confirmPayment': "Подтвердить оплату(de)",
	// 'recommendedPaymentSum': "Рекомендуемая сумма к оплате(de)",
	// 'totalPaymentSum': "Всего сумма к оплате(de)",
	// 'lowerThanRecommendedSum': "Сумма меньше рекомендуемой(de)",
	// 'addStage': "Добавить этап(de)",
	// 'sendForApproval': "Отправить на утверждение(de)",
	// 'edit': "Редактировать(de)",
	// 'approve': "Утвердить(de)",
	// 'firstlyAddWorkTypeToOrder': "Добавьте сначала тип работы к заказу(de)",
	// 'youConfirmedPaymentSuccessfully': "Вы успешно подтвердили оплату(de)",
	// 'dataWasSentToClientForApproval': "Данные отправленные на утверждение клиенту(de)",
	// 'dataWasSentForApproval': "Данные отправленны на утверждение(de)",
	// 'youMarkedStageAs': "Вы отметили этап как(de)",
	// 'stageWasMovedToStatus': "Заказ перемещен в статут(de)",
	// 'payRewardToAuthor': "Выплатить автору вознаграждение(de)",
	// 'authorsReward': "Вознаграждение автора(de)",
	// 'pay': "Выплатить(de)",
	// 'doCancel': "Отменить(de)",
	// 'indicateFailureReason': "Укажите причину провала(de)",
	// 'informationAboutOrder': "Информация о заказе(de)",
	// 'workName': "Название работы(de)",
	// 'clientsComment': "Комментарий клиента(de)",
	// 'recommendedSumShort': "Реком. сумма(de)",
	// 'add': "Добавить(de)",
	// 'paymentMethod': "Способ оплаты(de)",
	// 'filesFromAuthor': "Файлы от автора(de)",
	// 'send': "Отправить(de)",
	// 'sendAutomatically': "Отправлять автоматически(de)",
	// 'filesWasSentToClient': "Файлы были отправлены клиенту(de)",
	// 'refuse': "Отказаться(de)",
	// 'youWantToCompleteOrder': "Вы собираетесь завершить заказ(de)",
	// 'thisActionIsIrreversible': "Данное действие необратимо(de)",
	// 'completeOrder': "Завершить заказ(de)",
	// 'orderIsCompletedSuccessfully': "Заказ успешно завершен(de)",
	// 'writeToManager': "Написать менеджеру(de)",
	// 'discuss': "Обсуждается(de)",
	// 'creationDate': "Дата создания(de)",
	// 'calculatedSum': "Расчетная цена(de)",
	// 'includingVAT': "включая НДС(de)",
	// 'assign': "Назначить(de)",
	// 'chooseManager': "Выберите менеджера(de)",
	// 'passwordRecovery': "Восстановление пароля(de)",
	// 'enterYourEmailAndWeWillSendYouNewPassword': "Введите свой email и мы отправим вам новый пароль(de)",
	// 'recoverPassword': "Восстановить пароль(de)",
	// 'toLoginPage': "На страницу входа(de)",
	// 'newPasswordIsGeneratedAndSentToMail': "Новый пароль отправлен на почту(de)",
	// 'registration': "Регистрация(de)",
	// 'fillFormBelowToCreateNewAccount': "Заполните форму ниже, чтобы создать новую учетную запись(de)",
	// 'youAreAlreadyLoggedIn': "Вы уже вошли в систему!(de)",
	// 'entrance': "Вход(de)",
	// 'welcomeBack': "С возвращением(de)",
	// 'pleaseLoginToYourAccount': "Пожалуйста, войдите в свой аккаунт(de)",
	// 'password': "Пароль(de)",
	// 'repeatPassword': "Повторите пароль(de)",
	// 'newPassword': "Новый пароль(de)",
	// 'yes': "Да(de)",
	// 'no': "Нет(de)",
	// 'confirmDeletion': "Подтвердите удаление(de)",
	// 'doYouWantToDelete': "Вы собираетесь удалить(de)",
	// 'registrationLinkCreation': "Создание ссылки для регистрации(de)",
	// 'linkToRegistrationForm': "Ссылка на форму регистрации(de)",
	// 'generate': "Сгенерировать(de)",
	// 'close': "Закрыть(de)",
	// 'nickname': "Никнейм(de)",
	// 'emailForPayment': "Email для выплат(de)",
	// 'phone': "Телефон(de)",
	// 'sex': "Пол(de)",
	// 'country': "Страна(de)",
	// 'birthDate': "Дата рождения(de)",
	// 'surname': "Фамилия(de)",
	// 'profile': "Профиль(de)",
	// 'subjects': "Предметы(de)",
	// 'aboutYourself': "О себе(de)",
	// 'dataIsSaved': "Данные сохранены(de)",
	// 'totalOrdersCount': "Общее количество заказов(de)",
	// 'success': "Успешность(de)",
	// 'personName': "Имя(de)",
	// 'changeWorkType': "Изменить тип работы(de)",
	// 'shortRussian': "рус(de)",
	// 'shortGerman': "нем(de)",
	// 'totalTicketsAmount': "Общее количество тикетов(de)",
	// 'activatedTickets': "Активных тикетов(de)",
	// 'income': "Доход(de)",
	// 'totalIncome': "Общий доход(de)",
	// 'clientEditing': "Редактирование клиента(de)",
	// 'additionalEmail': "Дополнительный Email(de)",
	// 'activatedOrder': "Активных заказов(de)",
	// 'changingManagerRequest': "Запрос на смену менджера(de)",
	// 'newManager': "Новый менеджер(de)",
	// 'confirm': "Подтвердить(de)",
	// 'decline': "Отклонить(de)",
	// 'firstlySelectManager': "Нужно сначала указать менеджера(de)",
	// 'changingManagerRequestIsSent': "Отправлен запрос на смену менеджера(de)",
	// 'requestWasDeclined': "Запрос был отменен(de)",
	// 'searchByName': "Поиск по имени(de)",
	// 'actions': "Действия(de)",
	// 'totalOrders': "Всего заказов(de)",
	// 'paidOrder': "Оплаченных заказов(de)",
	// 'hangingOrders': '"Повисшие" заказы(de)',
	// 'sitesPreferences': "Настройки для сайтов(de)",
	// 'managerEditing': "Редактирование менеджера(de)",
	// 'managerCreating': "Создание менеджера(de)",
	// 'sitesSettings': "Настройки сайта(de)",
	// 'basicPrices': "Базовые цены(de)",
	// 'workTypesVisibility': "Видимость типов работ(de)",
	// 'invoicesData': "Данные для инвойсов(de)",
	// 'changesIsSavedSuccessfully': "Изменения успешно сохранены(de)",
	// 'siteWasCreatedSuccessfully': "Сайт был успешно создан(de)",
	// 'managersFee': "Гонорар менеджера(de)",
	// 'deleteLogo': "Удалить лого(de)",
	// 'firmInfo': "Информация о фирме(de)",
	// 'termsAndConditions': "Условия и положения(de)",
	// 'part': "часть(de)",
	// 'changeLogo': "Изменить лого(de)",
	// 'mainLogo': "Основной цвет(de)",
	// 'additionalColor': "Дополнительный цвет(de)",
	// 'showForJunior': "Показать для Junior(de)",
	// 'showForMiddle': "Показать для Middle(de)",
	// 'showForSenior': "Показать для Senior(de)",
	// 'general': "Общая(de)",
	// 'bySites': "По сайтам(de)",
	// 'openDiscuss': "Открыть обращение(de)",
	// 'opened': "Открытые(de)",
	// 'number': "Номер(de)",
	// 'discussTheme': "Тема обращения(de)",
	// 'status': "Статус(de)",
	// 'lastAnswer': "Последний ответ(de)",
	// 'answerReceived': "Ответ получен(de)",
	// 'waitingToAnswer': "Ожидает ответа(de)",
	// 'closed': "Закрытые(de)",
	// 'isClosed': "Закрыто(de)",
	// 'openNewDiscuss': "Открыть новое обращение(de)",
	// 'discussText': "Текст обращения(de)",
	// 'doYouWantToCloseDiscuss': "Вы собираетесь закрыть обращение(de)",
	// 'closeDiscuss': "Закрыть обращение(de)",
	// 'aDiscuss': "Обращение(de)",
	// 'discussStatus': "Статус обращения(de)",
	// 'write': "Написать(de)",
	// 'techSupport': "Техподдержка(de)",
	// 'pendingConsideration': "Ожидает рассмотрения(de)",
	// 'paidOut': "Выплачено(de)",
	// 'rejected': "Отклонено(de)",
	// 'payRequest': "Запрос на выплату(de)",
	// 'writeHowMuchYouWantToWithdraw': "Укажите какую сумму Вы хотите вывести(de)",
	// 'rejectPayment': "Отклонить платеж(de)",
	// 'paymentRejectingReason': "Причина отклонения платежа(de)",
	// 'currentBalance': "Текущий баланс(de)",
	// 'withdraw': "Вывести(de)",
	// 'rejectSuccessfully': "Успешно отклонено(de)",
	// 'idTransaction': "ID транзакция(de)",
	// 'sum': "Сумма(de)",
	// 'paymentSystem': "Платежная система(de)",
	// 'paymentRequests': "Запросы на выплату(de)",
	// 'paymentsHistory': "История для выплат(de)",
	// 'user': "Пользователь(de)",
	// 'rejectedPayments': "Отклоненные выплаты(de)",
	// 'addWorkType': "Добавить тип работы(de)",
	// 'responseText': "Текст ответа(de)",
	// 'addAnswer': "Добавить ответ(de)",
	// 'ago': "назад(de)",
	// 'month(1)': "месяц(de)",
	// 'month(2-5)': "месяца(de)",
	// 'month(6-0': "месяцев(de)",
	// 'more': "Больше(de)",
	// 'lessThanMonth': "Меньше месяца(de)",
	// 'markAllAsRead': "Отметить все как прочитанные(de)",
	// 'orders': "Заказы(de)",
	// 'techSupportShort': "Тех. поддержка(de)",
	// 'exchangePageName': "Биржа(de)",
	// 'tickets': "Тикеты(de)",
	// 'statistics': "Статистика(de)",
	// 'finances': "Финансы(de)",
	// 'tasks': "Дела(de)",
	// 'clients': "Клиенты(de)",
	// 'managers': "Менеджеры(de)",
	// 'authors': "Авторы(de)",
	// 'sites': "Сайты(de)",
	// 'workTypes': "Типы работ(de)",
	// 'templateAnswers': "Шаблонные ответы(de)",
	// 'scheduledTasks': "Запланированные дела(de)",
	// 'all': "Все(de)",
	// 'notDone(many)': "Не выполнены(de)",
	// 'sort': "Сортировка(de)",
	// 'tasksCalendar': "Календарь дел(de)",
	// 'languages': "Языки(de)",
	// 'accessDenied': "Доступ запрещён(de)",
	// 'addPhoto': "Добавьте фото(de)",
	// 'male': "Мужчина(de)",
	// 'female': "Женщина(de)",
	// 'searchByOrderName': "Поиск по названию(de)",
	// 'addOrder': "Добавить заказ(de)",
	// 'doYouWantToRejectOrder': "Вы собиретесь откзаться от заказа(de)",
	// 'yourPersonalManager': "Ваш личный менеджер(de)",
	// 'requestAnotherManager': "Запросить другого менеджера(de)",
	// 'writeReason': "Опишите причину(de)",
	// 'profileEditing': "Редактирование профиля(de)",
	// 'changePhoto': "Изменить фото(de)",
	// 'deletePhoto': "Удалить фото(de)",
	// 'chatWithYourManager(p1)': "Чат с вашим(de)",
	// 'chatWithYourManager(p2)': "Менеджером(de)",
	// 'chatByOrder': "Чат по заказу(de)",
	// 'search': "Поиск(de)",
	// 'copywriter': "Копирайтер(de)",
	// 'admin': "Админ(de)",
	// 'successNotification': "Успешно(de)",
	// 'dangerNotification': "Внимание(de)",
	// 'errorNotification': "Ошибка(de)",
	// 'fieldFilledIncorrect': "Поле заполнено некорректно",


	// --------------- V2
	// 'newMessagesCountDisplay': "Новых(de)",
	// 'logout': "Выйти(de)",
	// 'russian': "Русский(de)",
	// 'german': "Немецкий(de)",
	// "sunday": "Воскресение(de)",
	// "monday": "Понедельник(de)",
	// "tuesday": "Вторник(de)",
	// "wednesday": "Среда(de)",
	// "thursday": "Четверг(de)",
	// "friday": "Пятница(de)",
	// "saturday": "Суббота(de)",
	// "sundayShort": "вс(de)",
	// "mondayShort": "пн(de)",
	// "tuesdayShort": "вт(de)",
	// "wednesdayShort": "ср(de)",
	// "thursdayShort": "чт(de)",
	// "fridayShort": "пт(de)",
	// "saturdayShort": "сб(de)",
	// "january": "Январь(de)",
	// "february": "Февраль(de)",
	// "march": "Март(de)",
	// "april": "Апрель(de)",
	// "may": "Май(de)",
	// "june": "Июнь(de)",
	// "july": "Июль(de)",
	// "august": "Август(de)",
	// "september": "Сентябрь(de)",
	// "october": "Октябрь(de)",
	// "november": "Ноябрь(de)",
	// "december": "Декабрь(de)",
	// "januaryGenitive": "Января(de)",
	// "februaryGenitive": "Февраля(de)",
	// "marchGenitive": "Марта(de)",
	// "aprilGenitive": "Апреля(de)",
	// "mayGenitive": "Мая(de)",
	// "juneGenitive": "Июня(de)",
	// "julyGenitive": "Июля(de)",
	// "augustGenitive": "Августа(de)",
	// "septemberGenitive": "Сентября(de)",
	// "octoberGenitive": "Октября(de)",
	// "novemberGenitive": "Ноября(de)",
	// "decemberGenitive": "Декабря(de)",
	// --------------- end V2

	// --------------- V3
	// "topic": "Тема(de)",
	// "finished": "Завершенные(de)",
	// "incomeTotal": 'Gross',
	// "stages": "Этапы(de)",
	// "confirmUploading": "Подтвердить загрузку(de)",
	// "fileDeletedSuccessfully": "Файл успешно удален(de)",
	// "isConfirmingStage": "Этап сейчас на подтверждении менеджера(de)",
	// "changeTemplateAnswer": "Изменить шаблонный ответ(de)",
	// "pages": "{n} страниц(de) | {n} страница(de) | {n} страницы(de) | {n} страниц(de)",
	// "fileDeletionError": "Возникла ошибка при попытке удалить файл(de)",
	// "doYouWantToDeleteAuthorFromOrder": "Вы собираетесь удалить автора с заказа(de)",
	// "doYouWantToDeleteFile": "Вы собираетесь удалить файл(de)",
	// "youDeletedAuthorFromOrder": "Вы удалили автора с этого заказа(de)",
	// "mainColor": "Основной цвет(de)",
	// "noDataAvailable": "Данных не найдено(de)",
	// "secondsAgo": 'vor 0 Sekunden | vor {n} Sekunde | vor {n} Sekunden | vor {n} Sekunden | vor {n} Secunden',
	// "minutesAgo": "vor 0 Minuten | vor {n} Minute | vor {n} Minuten | vor {n} Minuten | vor {n} Minuten",
	// "hoursAgo": "vor 0 Stunden | vor {n} Stunde | vor {n} Stunden | vor {n} Stunden | vor {n} Stunden",
	// "daysAgo": "vor 0 Tage | vor {n} Tag | vor {n} Tage | vor {n} Tage | vor {n} Tagen",
	// "yearsAgo": "vor 0 Jahre | vor {n} Jahr | vor {n} Jahre | vor {n} Jahre | vor {n} Jahren",
	// "justNow": "Einfach jetzt",
	// --------------- end V3

	// "exchange": {
	// 	'name': 'Название(de)',
	// 	'area': 'Область(de)',
	// 	'type': 'Тип(de)',
	// 	'page': 'Страниц(de)',
	// 	'stage': 'Этапов(de)',
	// 	'price': 'Цена(de)',
	// 	'price_junior_middle': "Цена для Junior/Middle(de)",
	// 	'price_senior': "Цена для Senior(de)",
	// 	'deadline': 'Дедлайн(de)',
	// 	'accept': 'Взять в работу(de)',
	// 	'decline': 'Отклонить(de)',
	// 	'confirmAction': 'Подтвердите действие(de)',
	// 	'confirmActionText': 'Вы собираетесь взять в работу этот проект(de)',
	// 	'confirmActionTextFalse': 'Вы собираетесь отклонить приглашение в этот проект(de)',
	// 	'confirmPopup': 'Подтвердить(de)',
	// 	'order': 'Заказ(de)',
	// 	'countStages': 'Кол-во этапов(de)',
	// 	'nameWork': 'Название работы(de)',
	// 	'subject': 'Предметная область(de)',
	// 	'typeWork': 'Тип работы(de)',
	// 	'levelQuality': 'Уровень качества(de)',
	// 	'countPages': 'Количество страниц(de)',
	// 	'attachFile': 'Прикрепленный файл(de)',
	// 	'langWork': 'Язык выполнения(de)',
	// 	'comment': 'Комментарий(de)',
	// 	'getToWork': 'Взять работу(de)',
	// 	'filter': 'Фильтр(de)',
	// 	'searchToName': 'Поиск по названию(de)',
	// 	'level': 'Уровень(de)',
	// 	'off': 'От(de)',
	// 	'to': 'До(de)',
	// 	'reset': 'Сбросить(de)',
	// 	'inviteDecline': 'Инвайт отклоннен(de)',
	// 	'inviteDeclineText': 'Успешно отклонили инвайт(de)',
	// 	'inviteAccept': 'Инвайт принят(de)',
	// 	'inviteAcceptText': 'Спасибо, можете приступать к работе.(de)',
	// 	'requestSend': 'Заявка отправлена(de)',
	// 	'requestSendText': 'Спасибо, мы получили вашу зявку. Менеджер скоро ее подтвердит. Пожалуйста, подождите(de)',
	// 	'success': 'Успешно(de)',
	// 	'successText': 'Успешно выполнено(de)',
	// 	'deleteText': 'Успешно удалено(de)',
	// 	'acceptText': 'Успешно добавлено(de)',
	// },
	// "stats": {
	// 	"junior": 'Economy(de)',
	// 	"middle": 'Business(de)',
	// 	"senior": 'Academic(de)',
	// 	"income": 'Всего получено(de)',
	// 	"total": 'Чистая прибыль(de)',
	// 	"totalIncome": 'Доход(de)',
	// 	"privateIncome": 'Личный доход(de)',
	// 	"sitesCount": 'Сайтов(de)',
	// 	"paidOrdersCount": 'Оплаченных заказов(de)',
	// 	"waitingOrdersCount": '"Повисшие" заказы(de)',
	// 	"graphIncome": 'График личного дохода(de)',
	// 	"graphOrders": 'График заказов(de)',
	// 	"graphIncomeGlobal": 'График  дохода(de)',
	// 	"graphOrdersPaid": 'График зависших заказов(de)',
	// 	"completeOrder": 'Выполненные заказы(de)',
	// 	"successOrder": 'Успешность(de)',
	// 	"today": 'Сегодня(de)',
	// 	"yesterday": 'Вчера(de)',
	// 	"currentWeek": 'Текущая неделя(de)',
	// 	"prevWeek": 'Прошлая неделя(de)',
	// 	"current_month": 'Текущий месяц(de)',
	// 	"last_month": 'Прошлый месяц(de)',
	// 	"last_three_month": '3 месяца(de)',
	// 	"last_six_month": 'Пол года(de)',
	// 	"last_year": 'Год(de)',
	// 	"all_time": 'За все время(de)',
	// 	"active": "Активных заказов(de)",
	// 	"clientsCount": 'Клиентов(de)',
	// 	"authorsCount": 'Авторов(de)',
	// 	"managersCount": 'Менеджеров(de)',
	// 	"incomeTotal": 'Всего получено(de)',
	// 	"incomeClean": 'Чистая прибыль(de)',
	// 	"ordersCount": 'Всего заказов(de)',
	// 	"graphUsers": 'График новых пользователей(de)',
	// 	"graphQualityLevels": 'Заказы по уровням качества(de)',
	// 	"graphSubjects": 'Заказы по предметным областям(de)',
	// 	"graphAdminIncome": 'Прибыль(de)',
	// 	"newPaidTickets": 'Заказы(de)',
	// 	"completedTickets": 'Статусы завершенных заказов(de)',
	// 	"conversion": 'Конверсия(de)',
	// 	"date": 'Дата(de)',
	// 	"manager": 'Менеджер(de)',
	// 	"clients": 'Клиентов(de)',
	// 	"authors": 'Авторов(de)',
	// 	"mangers": 'Менеджеров(de)',
	// 	"graph_new": 'Новых тикетов(de)',
	// 	"paid": 'Оплаченных тикетов(de)',
	// 	"completed": 'Выполнено(de)',
	// 	"failed": 'Провалено(de)',
	// },
	//







	// "date": "Datum",
	// "Ticket": "Fahrkarte",
	// "Assign": "Zuordnen",
	// "Delete": "Löschen",
	// "Choose a manager": "Wählen Sie einen Manager",
	// "entrance": "Eingang",
	// "Welcome back! Please login to your account": "Willkommen zurück! Bitte loggen Sie sich in Ihren Account ein",
	// "Password recovery": "Passwort-Wiederherstellung",
	// "registration": "Anmeldung",
	// "Attempt to login": "Versuch dich anzumelden",
	// "You are already signed in": "Sie sind bereits angemeldet",
	// "Fill out the form below to create a new account": "Füllen Sie das folgende Formular aus, um ein neues Konto zu erstellen",
	// "Enter your email and we will send you a new password": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen ein neues Passwort",
	// "Go to login page": "Gehen Sie zur Anmeldeseite",
	// "Successfully": "Erfolgreich",
	// "Generated new password and sent by email": "Neues Passwort generiert und per E-Mail verschickt",
	// "Success": "Erfolg",
	// "Profile": "Profil",
	// "Nickname": "Spitzname",
	// "Telephone": "Telefon",
	// "Date of Birth": "Geburtsdatum",
	// "Tongue": "Zunge",
	// "About myself": "Über mich",
	// "Change photo": "Foto ändern",
	// "Delete photo": "Foto löschen",
	//
	// "old password": "Altes Passwort",
	// "New password": "Neues Passwort ",
	// "Add to": "Hinzufügen ",
	// "Confirm deletion": "Löschung bestätigen ",
	// "Are you going to delete": "Wirst du löschen ",
	// "Create registration link": "Registrierungslink erstellen ",
	// "Create a": "Ein ... kreieren ",
	// "Link to registration form": "Link zum Anmeldeformular ",
	//
	// "Floor": "Fußboden",
	// "Total number of orders": "Gesamtzahl der Bestellungen",
	// "Name": "Name",
	// "Technical": "Technisch",
	// "A country": "Ein Land",
	// "Change manager request": "Manageranforderung ändern",
	// "Confirm": "Bestätigen",
	// "Reject": "Ablehnen",
	// "Client editing": "Client-Bearbeitung",
	// "Surname": "Nachname",
	// "Save": "sparen",
	// "Cancel": "Stornieren",
	// "Change the type of work": "Ändern Sie die Art der Arbeit",
	// "Add work type": "Arbeitstyp hinzufügen",
	// "Successfully remotely": "Erfolgreich aus der Ferne",
	// "Successfully changed": "Erfolgreich geändert",
	// "Total number of tickets": "Gesamtzahl der Tickets",
	// "Income": "Einkommen",
	// "Money transferred": "Geld überwiesen",
	// "Total number of orders ": "Gesamtzahl der Bestellungen",
	// "Active orders": "Aktive Bestellungen",
	// "Additional": "Zusätzlich",
	// "Edit": "Bearbeiten",
	// "A request has been sent to change the manager": "Es wurde eine Anfrage zum Ändern des Managers gesendet",
	// "Search by name.": "Suche mit Name.",
	// "Add case": "Fall hinzufügen",
	// "Description": "Beschreibung",
	// "Performed": "Durchgeführt",
	// "Added successfully": "Erfolgreich hinzugefügt",
	// "Money": "Geld",
	// "Editing a manager": "Manager bearbeiten",
	// "Email for payments": "E-Mail für Zahlungen",
	// "Order successfully created": "Bestellung erfolgreich erstellt",
	// "Is being discussed": "Wird diskutiert",
	// "date of creation": "Erstelldatum",
	// "Namen": "Name",
	// "Author": "Autor",
	// "Region": "Region",
	// "Level": "Niveau",
	// "Deadline": "Frist",
	// "Pages": "Seiten",
	// "nature": "Natur",
	// "Waiting for a response": "Auf eine Antwort warten",
	// "Answer received": "Antwort erhalten",
	// "Appeal status": "Einspruchsstatus",
	// "Write a message": "Eine Nachricht schreiben",
	// "Close chat": "Chat schließen",
	// "Close appeal": "Enge Anziehungskraft",
	// "Open a new ticket": "Öffnen Sie ein neues Ticket",
	// "Message text": "Nachrichtentext",
	// "Send message": "Nachricht senden",
	// "Message subject": "Betreff der Nachricht",
	// "Upload a photo": "Lade ein Foto hoch",
	// "Total works": "Insgesamt arbeitet",
	// "Current works": "Aktuelle Arbeiten",
	// "Favorites": "Favoriten",
	// "Refuse to work": "Weigere dich zu arbeiten",
	// "The client is not responding": "Der Client antwortet nicht",
	// "to write a message": "eine Nachricht schreiben",
	// "Technical support": "Technischer Support",
	// "Data saved": "Daten gespeichert",
	// "room": "Zimmer",
	// "Subject of the appeal": "Gegenstand der Beschwerde",
	// "Last Reply": "Letzte Antwort",
	// "Closed": "Geschlossen",
	// "Contractor applications": "Anträge von Auftragnehmern",
	// "To invite": "Einladen",
	// "Select": "Wählen",
	// "Payment details": "Zahlungsdetails",
	// "Approve": "Genehmigen",
	// "Submit for approval": "Zur Genehmigung einreichen",
	// "Failed": "Gescheitert",
	// "You are about to complete the order": "Sie sind im Begriff, die Bestellung abzuschließen",
	// "This action is irreversible": "Diese Aktion ist irreversibel",
	// "Selected author to order": "Ausgewählter Autor auf Bestellung",
	// "Data sent for client approval": "Daten zur Genehmigung durch den Kunden gesendet",
	// "Thank you, we have received your application": "Vielen Dank, wir haben Ihre Bewerbung erhalten",
	// "You are about to refuse an order": "Sie sind im Begriff, eine Bestellung abzulehnen",
	// "English": "Englisch",
	// "Diploma": "Diplom",
	// "Natural Sciences": "Naturwissenschaften",
	// "Client Email": "Kunden-E-Mail",
	// "Newton's law": "Newtons Gesetz",
	// "Add stage": "Bühne hinzufügen",
	// "Invitations sent": "Einladungen gesendet",
	// "Data has been sent for approval": "Die Daten wurden zur Genehmigung gesendet",
	// "Add a ticket": "Fügen Sie ein Ticket hinzu",
	// "Search by name and client": "Suche nach Name und Kunde",
	// "Case review": "Fallbesprechung",
	// "Confirmed": "Bestätigt",
	// "In processing": "In Bearbeitung",
	// "Searching for an artist": "Auf der Suche nach einem Künstler",
	// "In the process": "Dabei",
	// "Completed": "Abgeschlossen",
	// "Not executed with payment": "Nicht mit Zahlung ausgeführt",
	// "Pending consideration": "Ausstehende Überlegungen",
	// "Paid out": "Ausbezahlt",
	// "Reject payment": "Zahlung ablehnen",
	// "Reason for declining payment": "Grund für die Ablehnung der Zahlung",
	// "Current balance": "Aktueller Saldo",
	// "Withdraw": "Abheben",
	// "Pay out": "Auszahlen",
	// "the amount you host withdraw": "Der Betrag, den Sie als Host abheben",
	// "Transaction ID": "Transaktions-ID",
	// "Payment system": "Bezahlsystem",
	// "Payment requests": "Zahlungsanfragen",
	// "History for payments": "Zahlungsverlauf",
	// "Declined payments": "Abgelehnte Zahlungen",
}

